// extracted by mini-css-extract-plugin
export var actions = "_di-g";
export var benefitCard = "_di-b";
export var benefitIcon = "_di-d";
export var benefitLabel = "_di-f";
export var benefits = "_di-a";
export var benefitsSection = "_di-8";
export var bodyText = "_di-7";
export var closeButton = "_di-2";
export var content = "_di-3";
export var eyebrow = "_di-4";
export var heading = "_di-5";
export var image = "_di-i";
export var imagePanel = "_di-h";
export var modal = "_di-0";
export var offerCard = "_di-c";
export var offerIcon = "_di-e";
export var sectionLabel = "_di-9";
export var shell = "_di-1";
export var title = "_di-6";